export function createDegreeFormValidator(values) {
  const errors: any = {};
  if (!values.name) {
    errors.name = "Name field is required";
  }

  return errors;
}
